module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/push-notification",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bell"
  }), _c('span', [_vm._v("Push Notification")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d6e281e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/push_notif/Navigation.vue
// module id = 1352
// module chunks = 0